import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  connect() {
    this.element.classList.add("flatpickr-input");
    flatpickr(this.element, { dateFormat: 'Y-m-d', allowInput: true });
  }
}
